/* import __COLOCATED_TEMPLATE__ from './signup-chip-freetext.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';

/** @type {function} */
const noop = () => { };

/** @module */
const SignupChipFreetext = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {Ember.A} */
  selected: A([]),

  /** @type {string} */
  label: '',

  /** @type {string} */
  _internalValue: '',

  /** @type {Ember.ComputedProperty} */
  _selectedServices: computed('selected.[]', function() {
    return this.get('selected').map(key => ({ key, value: key }));
  }),

  /** @inheritDoc */
  actions: {
    /**
     *
     */
    handleBlur() {
      this.set('_internalValue', '');
      this.get('onblur')?.();
    },

    /**
     * @param {string} value
     */
    handleInput(value) {
      this.set('_internalValue', value);
    },

    /**
     * @param {KeyboardEvent} e
     */
    handleKeyDown(e) {
      switch (e.key) {
        case 'Enter':
          const val = this.get('_internalValue');

          if (!val) {
            break;
          }

          e.preventDefault();
          this.set('_internalValue', '');

          if (!this.get('selected').includes(val)) {
            this.get('onadded')?.(val);
          }

          break;
      }
    },

    /**
     * @param {Object} obj
     * @param {string} obj.value
     */
    handleRemoved({ value }) {
      this.get('onremoved')?.(value);
    },
  },
});

export default SignupChipFreetext;
